import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flagClass',
  standalone: true,
    pure: true, 
})
export class FlagsPipe implements PipeTransform {
  transform(code: string): string {
    switch (code) {
      case 'ca': return 'es-ct';
      case 'en': return 'gb';
      case 'zh': return 'cn';
      default: return code;
    }
  }
}